import { z } from "zod";

export const errorResponseSchema = z.object({
  code: z.string(),
  message: z.string().optional(),
  info: z.string().optional(),
});
